<div class="skeleton-list-header-container">
  <div class="skeleton-sort-edit-button"></div>
  <div class="skeleton-item-add-button"></div>
  <div class="skeleton-search"></div>
  <ng-container *ngIf="showRARs">
    <div class="skeleton-rags"></div>
  </ng-container>
</div>
